import Vue from 'vue'
import axios from 'axios'
const Urls = require("../../src/fetch/config");
import { Dialog } from 'vant';
Vue.prototype.$axios = axios
axios.defaults.timeout = 60000
if (process.env.NODE_ENV !== 'development') {
  //开发环境下的代理地址，解决本地跨域跨域，配置在config目录下的index.js dev.proxyTable中
  axios.defaults.baseURL = Urls.PROXYROOT
}

axios.interceptors.request.use(
  config => {
    let token = localStorage.getItem('token')
    if (token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = token;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  })

axios.interceptors.response.use(
  response => {  //成功请求到数据
    // //这里根据后端提供的数据进行对应的处理
    if (response.data.code == 0||response.data.code == 411) {
      return response
    } else if (response.data.code == 401) {
      localStorage.clear()
      window.location.reload()
      return Promise.reject(response);
    } else if (response.data.code == 10001) {
      Vue.prototype.$msgTip.showTip({
          content: response.data.message
      })
      
      return Promise.reject(response);
    }  else {
      Dialog.alert({
        title: '提示',
        message: response.data.message
      })
      return Promise.reject(response);
    }
  },
  error => {  //响应错误处理
    console.log('error');
    console.log(error);
    console.log(JSON.stringify(error));
    let text = JSON.parse(JSON.stringify(error)).response.status === 404
      ? '404'
      : '网络异常，请重试';
    return Promise.reject(error)
  }
)







// WEBPACK FOOTER //
// ./src/axios/index.js